import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import i18n from '../i18n'
import Footer from '../components/Footer'

const en = i18n.getFixedT('en')

export default function TermsPage() {
  useEffect(() => {
    document.title = 'Terms and Conditions | Duplicate Destroyer'
  }, [])

  const items = en('terms.items', { returnObjects: true }) as { q: string; a: string }[]

  return (
    <div className="min-h-screen font-sans selection:bg-neonPink selection:text-white">
      <header className="bg-cardBg border-b-2 border-slate-200 dark:border-slate-800 px-6 py-4 flex items-center justify-between transition-colors">
        <Link
          to="/"
          className="text-xl font-black tracking-tighter uppercase italic text-neonBlue hover:brightness-125 transition-all"
        >
          Duplicate Destroyer
        </Link>
        <Link
          to="/"
          className="flex items-center gap-2 text-sm font-black uppercase tracking-widest text-slate-500 dark:text-slate-300 hover:text-neonBlue transition-colors"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to App
        </Link>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-black uppercase tracking-tighter mb-2 text-center">
          Terms and Conditions
        </h1>
        <div className="h-1.5 w-24 bg-neonBlue mx-auto mb-12 rounded-full shadow-[0_0_10px_rgba(0,234,255,0.5)]" />

        <div className="space-y-6">
          {items.map((item, i) => (
            <div key={i} className="clay-card rounded-twelve p-8">
              <h2 className="text-xl font-black mb-4 text-neonBlue">{item.q}</h2>
              <div
                className="text-slate-700 dark:text-slate-200 font-bold leading-relaxed"
                dangerouslySetInnerHTML={{ __html: item.a }}
              />
            </div>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  )
}
